import { css } from 'styled-components';
import { TTypography } from '../../components/Global/Atomics/types';

export const handleTypography = (props: TTypography) => {
    switch (props.typography) {
        // DISPLAY
        case 'display-xxl':
            return css`
                font-size: 80px;
                font-weight: 700;
                line-height: 6.25rem;
            `;
        case 'display-xl':
            return css`
                font-size: 72px;
                font-weight: 700;
                line-height: 5.625rem;
            `;
        case 'display-l':
            return css`
                font-size: 64px;
                font-weight: 700;
                line-height: 5rem;
            `;
        case 'display-m':
            return css`
                font-size: 56px;
                font-weight: 500;
                line-height: 4.375rem;
            `;
        case 'display-s':
            return css`
                font-size: 48px;
                font-weight: 500;
                line-height: 3.75rem;
            `;
        case 'display-xs':
            return css`
                font-size: 40px;
                font-weight: 500;
                line-height: 3.125rem;
            `;

        // TEXT BOLD
        case 'text-xxl-bold':
            return css`
                font-size: 32px;
                font-weight: 700;
                line-height: 3rem;
            `;
        case 'text-xl-bold':
            return css`
                font-size: 24px;
                font-weight: 700;
                line-height: 2.25rem;
            `;
        case 'text-l-bold':
            return css`
                font-size: 20px;
                font-weight: 700;
                line-height: 1.875rem;
            `;
        case 'text-m-bold':
            return css`
                font-size: 16px;
                font-weight: 700;
                line-height: 1.5rem;
            `;
        case 'text-s-bold':
            return css`
                font-size: 14px;
                font-weight: 700;
                line-height: 1.3125rem;
            `;
        case 'text-xs-bold':
            return css`
                font-size: 12px;
                font-weight: 700;
                line-height: 1.125rem;
            `;

        // TEXT SEMIBOLD
        case 'text-xxl-semibold':
            return css`
                font-size: 32px;
                font-weight: 600;
                line-height: 3rem;
            `;
        case 'text-xl-semibold':
            return css`
                font-size: 24px;
                font-weight: 600;
                line-height: 2.25rem;
            `;
        case 'text-l-semibold':
            return css`
                font-size: 20px;
                font-weight: 600;
                line-height: 1.875rem;
            `;
        case 'text-m-semibold':
            return css`
                font-size: 16px;
                font-weight: 600;
                line-height: 1.5rem;
            `;
        case 'text-s-semibold':
            return css`
                font-size: 14px;
                font-weight: 600;
                line-height: 1.3125rem;
            `;
        case 'text-xs-semibold':
            return css`
                font-size: 12px;
                font-weight: 600;
                line-height: 1.125rem;
            `;

        // TEXT MEDIUM
        case 'text-xxl-medium':
            return css`
                font-size: 32px;
                font-weight: 500;
                line-height: 3rem;
            `;
        case 'text-xl-medium':
            return css`
                font-size: 24px;
                font-weight: 500;
                line-height: 2.25rem;
            `;
        case 'text-l-medium':
            return css`
                font-size: 20px;
                font-weight: 500;
                line-height: 1.875rem;
            `;
        case 'text-m-medium':
            return css`
                font-size: 16px;
                font-weight: 500;
                line-height: 1.5rem;
            `;
        case 'text-s-medium':
            return css`
                font-size: 14px;
                font-weight: 500;
                line-height: 1.3125rem;
            `;
        case 'text-xs-medium':
            return css`
                font-size: 12px;
                font-weight: 500;
                line-height: 1.125rem;
            `;

        // TEXT REGULAR
        case 'text-xxl-regular':
            return css`
                font-size: 32px;
                font-weight: 400;
                line-height: 3rem;
            `;
        case 'text-xl-regular':
            return css`
                font-size: 24px;
                font-weight: 400;
                line-height: 2.25rem;
            `;
        case 'text-l-regular':
            return css`
                font-size: 20px;
                font-weight: 400;
                line-height: 1.875rem;
            `;
        case 'text-m-regular':
            return css`
                font-size: 16px;
                font-weight: 400;
                line-height: 1.5rem;
            `;
        case 'text-s-regular':
            return css`
                font-size: 14px;
                font-weight: 400;
                line-height: 1.3125rem;
            `;
        case 'text-xs-regular':
            return css`
                font-size: 12px;
                font-weight: 400;
                line-height: 1.125rem;
            `;

        // TEXT LIGHT
        case 'text-xxl-light':
            return css`
                font-size: 32px;
                font-weight: 300;
                line-height: 3rem;
            `;
        case 'text-xl-light':
            return css`
                font-size: 24px;
                font-weight: 300;
                line-height: 2.25rem;
            `;
        case 'text-l-light':
            return css`
                font-size: 20px;
                font-weight: 300;
                line-height: 1.875rem;
            `;
        case 'text-m-light':
            return css`
                font-size: 16px;
                font-weight: 300;
                line-height: 1.5rem;
            `;
        case 'text-s-light':
            return css`
                font-size: 14px;
                font-weight: 300;
                line-height: 1.3125rem;
            `;
        case 'text-xs-light':
            return css`
                font-size: 12px;
                font-weight: 300;
                line-height: 1.125rem;
            `;

        // UI SEMIBOLD
        case 'ui-xl-semibold':
            return css`
                font-size: 20px;
                font-weight: 600;
                line-height: 1.25rem;
            `;
        case 'ui-l-semibold':
            return css`
                font-size: 18px;
                font-weight: 600;
                line-height: 1.125rem;
            `;
        case 'ui-m-semibold':
            return css`
                font-size: 16px;
                font-weight: 600;
                line-height: 1rem;
            `;
        case 'ui-s-semibold':
            return css`
                font-size: 14px;
                font-weight: 600;
                line-height: 0.875rem;
            `;
        case 'ui-xs-semibold':
            return css`
                font-size: 12px;
                font-weight: 600;
                line-height: 0.75rem;
            `;
        case 'ui-xxs-semibold':
            return css`
                font-size: 10px;
                font-weight: 600;
                line-height: 0.625rem;
            `;

        // UI MEDIUM
        case 'ui-xl-medium':
            return css`
                font-size: 20px;
                font-weight: 500;
                line-height: 1.25rem;
            `;
        case 'ui-l-medium':
            return css`
                font-size: 18px;
                font-weight: 500;
                line-height: 1.125rem;
            `;
        case 'ui-m-medium':
            return css`
                font-size: 16px;
                font-weight: 500;
                line-height: 1rem;
            `;
        case 'ui-s-medium':
            return css`
                font-size: 14px;
                font-weight: 500;
                line-height: 0.75rem;
            `;
        case 'ui-xs-medium':
            return css`
                font-size: 12px;
                font-weight: 500;
                line-height: 0.625rem;
            `;
        case 'ui-xxs-medium':
            return css`
                font-size: 10px;
                font-weight: 500;
                line-height: 2.25rem;
            `;

        // UI REGULAR
        case 'ui-xl':
            return css`
                font-size: 20px;
                font-weight: 400;
                line-height: 1.25rem;
            `;
        case 'ui-l':
            return css`
                font-size: 18px;
                font-weight: 400;
                line-height: 1.125rem;
            `;
        case 'ui-m':
            return css`
                font-size: 16px;
                font-weight: 400;
                line-height: 1rem;
            `;
        case 'ui-s':
            return css`
                font-size: 14px;
                font-weight: 400;
                line-height: 0.875rem;
            `;
        case 'ui-xs':
            return css`
                font-size: 12px;
                font-weight: 400;
                line-height: 0.75rem;
            `;
        case 'ui-xxs':
            return css`
                font-size: 10px;
                font-weight: 400;
                line-height: 0.625rem;
            `;

        default:
            break;
    }
};
